import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

import { MainLayoutComponent } from "@app/shared/layout/app-layouts/main-layout.component";
import { AuthLayoutComponent } from "@app/shared/layout/app-layouts/auth-layout.component";
import { AuthGuard } from "@app/core/guards/auth.guard";
import { AdminGuard } from "@app/core/guards/admin.guard";

const routes: Routes = [
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [AuthGuard],
    children: [
        {
            path: '', redirectTo: 'home', pathMatch: 'full'
        },
        {
            path: 'home',
            loadChildren: './features/home/home.module#HomeModule'
        },
        {
          path: 'monitoring',
          loadChildren: './features/monitoring/monitoring.module#MonitoringModule',
          canActivateChild: [AdminGuard],
        },
        {
          path: 'shops',
          loadChildren: './features/shops/shops.module#ShopsModule',
          canActivateChild: [AdminGuard],
          data: { pageTitle: "Shops" }
        },
        {
          path: 'users',
          loadChildren: './features/users/users.module#UsersModule',
          canActivateChild: [AdminGuard],
          data: { pageTitle: "Users" }
        },
        {
          path: "orders",
          loadChildren: "./features/orders/orders.module#OrdersModule",
          data: { pageTitle: "Orders" }
        },
        {
          path: "promotions",
          loadChildren: "./features/promotions/promotions.module#PromotionsModule",
          canActivateChild: [AdminGuard],
          data: { pageTitle: "Promociones" }
        },
        {
          path: "products",
          loadChildren: "./features/products/products.module#ProductsModule",
          data: { pageTitle: "Products" }
        },
        {
          path: "reports",
          loadChildren: "./features/reports/reports.module#ReportsModule",
          canActivateChild: [AdminGuard],
          data: { pageTitle: "Reportes" }
        },

        {
          path: "configuration",
          loadChildren: "./features/configuration/configuration.module#ConfigurationModule",
          canActivateChild: [AdminGuard],
          data: { pageTitle: "Configuration" }
        },
        
        {
          path: "category-shops",
          loadChildren: "./features/category-shops/category-shops.module#CategoryShopsModule",
          canActivateChild: [AdminGuard],
          data: { pageTitle: "Category Shops" }
        },
    ]
},

{
  path: "auth",
  component: AuthLayoutComponent,
  loadChildren: "./features/auth/auth.module#AuthModule"
},

{
  path: "miscellaneous",
  loadChildren:
    "./features/miscellaneous/miscellaneous.module#MiscellaneousModule",
  data: { pageTitle: "Miscellaneous" }
},
{ path: "**", redirectTo: "miscellaneous/error404" }


];
//0100267053
@NgModule({
  imports: [RouterModule.forRoot(routes, {useHash: true})],
  exports: [RouterModule]
})
export class AppRoutingModule {}
